import lodashSnakeCase from 'lodash-es/snakeCase';

type UseStoryblokTrackingPageTypeReturn = {
    storyblokPageType: Ref<string>;
    setStoryblokPageType: (fullSlug: string) => void;
    clearStoryblokPageType: () => void;
};

export const useStoryblokTrackingPageType = (): UseStoryblokTrackingPageTypeReturn => {
    const storyblokPageType = useState<string>('tracking-storyblok-page-type', () => '');

    const setStoryblokPageType = (fullSlug: string): void => {
        storyblokPageType.value = lodashSnakeCase(fullSlug);
    };

    const clearStoryblokPageType = (): void => {
        storyblokPageType.value = '';
    };

    return { storyblokPageType, setStoryblokPageType, clearStoryblokPageType };
};
